function toggleCollectionView() {
  const shortDesc = document.getElementById("collection-description-short");
  const fullDesc = document.getElementById("collection-description-full");
  const toggleBtn = document.querySelector(".collection__description-toggle");

  if (!shortDesc || !fullDesc || !toggleBtn) return;

  toggleBtn.addEventListener("click", function () {
    const isVisible = toggleBtn.getAttribute("data-visible") === "true";
    if (isVisible) {
      shortDesc.style.display = "none";
      fullDesc.style.display = "";
      toggleBtn.setAttribute("data-visible", "false");
      toggleBtn.querySelector(".show-more").style.display = "none";
      toggleBtn.querySelector(".show-less").style.display = "";
    } else {
      shortDesc.style.display = "";
      fullDesc.style.display = "none";
      toggleBtn.setAttribute("data-visible", "true");
      toggleBtn.querySelector(".show-more").style.display = "";
      toggleBtn.querySelector(".show-less").style.display = "none";
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  toggleCollectionView();
});
